import { render, staticRenderFns } from "./register.vue?vue&type=template&id=deec01a6&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=deec01a6&prod&lang=scss&scoped=true"
import style1 from "./register.vue?vue&type=style&index=1&id=deec01a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deec01a6",
  null
  
)

export default component.exports